import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, createSlots as _createSlots, Fragment as _Fragment, createElementBlock as _createElementBlock, mergeProps as _mergeProps } from "vue"

import { ComponentsProvider } from '@/shared/ui'
import { OverlayLayout, Spin, Tabs } from '@/shared/ui';
import { nextTick, onBeforeMount, ref, watch } from 'vue';
import { type ProxyFormConfig } from './types';
import { Form as AForm } from 'ant-design-vue';
import { toast } from '@/shared/lib';
import { defaultRules } from './rules';


export default /*#__PURE__*/_defineComponent({
  __name: 'ProxyForm',
  props: {
    id: { default: null },
    preloadData: {},
    formConfig: {}
  },
  emits: ["error"],
  setup(__props: any, { expose: __expose, emit: __emit }) {

const props = __props

const serverErrors = ref({})
const phoneValidation = ref({})
const imageValidation = ref({})
const loading = ref(false)
const payload = ref<any>({})
const form = ref()
const activeTab = ref(0)

__expose({
  submit: async () => {
    return new Promise(async (resolve, reject) => {
      form.value.validate().then(async () => {
        try {
          const response = await handleSubmit();
          resolve(response);
        } catch (err : any) {
          if(err?.response?.status === 422){
            if(err.response.data.errors){
              serverErrors.value = err.response.data.errors
              await nextTick()
              form.value.validate().catch(() => {
                handleFailed(serverErrors.value);
              }).finally(() => {
                emit('error')
              })
            } else {
              emit('error', err)
            }
          } else {
            reject(err)
          }
        }
      }).catch((err : any) => {
        handleFailed(err);
        emit('error')
      });
    });
  },
  clearValidate
})

const emit = __emit


const tabs = props.formConfig?.tabs.map((tab) => { return { name: tab.name }})

async function imageValidationHandler (value: Record<string, boolean>) {
  setTimeout(async () => {
    imageValidation.value = { ...imageValidation.value, ...value }
    await nextTick()
    form.value.validateFields(Object.keys(value))
  }, 100)
}
async function clearValidate () {
  serverErrors.value = {}
  imageValidation.value = {}
  await nextTick()
  form.value.clearValidate()
};

async function handleSubmit() {
  try {
    return await props.formConfig?.api?.submit(payload.value, props.id ?? undefined)
  } catch(err) {
    throw err
  }
}

function handleFailed(err: any) {
  props.formConfig?.tabs?.every((tab, index: number) => {
    let field
    if(field = tab.fields.find((field) => err[field?.name] || err?.errorFields?.[0]?.name?.[0])) {
      activeTab.value = index
      moveToField(field.name)
      return false;
    }
  })
}

function moveToField(name : string){
  const drawerBody = document.querySelector('.ant-drawer-body');
  const element = document.getElementById(`anchor_${name}`);
  if (drawerBody && element) {
    const elementRect = element.getBoundingClientRect();
    const drawerBodyRect = drawerBody.getBoundingClientRect();
    const offsetTop = elementRect.top - drawerBodyRect.top;
    drawerBody.scrollTop = offsetTop;
  }
}

onBeforeMount(async () => {
  if(typeof props.formConfig?.api.preload === 'function') {
    const result = await props.formConfig.api.preload(props.preloadData)
    if(result){
      payload.value = result
    }
  }

  if(props.id){
    loading.value = true
    props.formConfig?.api.fetch ? props.formConfig.api.fetch(props.id).then((res : any) => {
      payload.value = res ?? {}
    }).catch(() => {
      toast({ type: 'error' })
    }).finally(() => {
      loading.value = false
    }) : loading.value = false
  }
})

watch(() => payload.value, () => {
  clearValidate()
}, { deep: true })

return (_ctx: any,_cache: any) => {
  return (_ctx.formConfig)
    ? (_openBlock(), _createBlock(_unref(AForm), _mergeProps({
        key: 0,
        ref_key: "form",
        ref: form,
        novalidate: ""
      }, _ctx.$attrs, {
        rules: _ctx.formConfig.rules ? _ctx.formConfig.rules(serverErrors.value, phoneValidation.value, imageValidation.value) : _unref(defaultRules)(_ctx.formConfig.tabs, serverErrors.value, phoneValidation.value, imageValidation.value),
        model: payload.value
      }), {
        default: _withCtx(() => [
          (loading.value)
            ? (_openBlock(), _createBlock(_unref(OverlayLayout), {
                key: 0,
                style: {"background":"var(--color-white)","opacity":".5"}
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(Spin))
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (!_ctx.formConfig.noTabs)
            ? (_openBlock(), _createBlock(_unref(Tabs), {
                key: 1,
                tabs: _unref(tabs),
                active_tab: activeTab.value,
                onChange: _cache[2] || (_cache[2] = ($event: any) => (activeTab.value = $event))
              }, _createSlots({ _: 2 }, [
                _renderList(_ctx.formConfig.tabs, (tab, index) => {
                  return {
                    name: `tab_${index}`,
                    fn: _withCtx(() => [
                      _createVNode(_unref(ComponentsProvider), {
                        model: payload.value,
                        fields: tab.fields,
                        onPhoneValidation: _cache[0] || (_cache[0] = ($event: any) => (phoneValidation.value = { ...phoneValidation.value, ...$event})),
                        onImageValidation: _cache[1] || (_cache[1] = ($event: any) => (imageValidationHandler($event)))
                      }, null, 8, ["model", "fields"])
                    ])
                  }
                })
              ]), 1032, ["tabs", "active_tab"]))
            : (_openBlock(true), _createElementBlock(_Fragment, { key: 2 }, _renderList(_ctx.formConfig.tabs, (tab) => {
                return (_openBlock(), _createBlock(_unref(ComponentsProvider), {
                  model: payload.value,
                  fields: tab.fields,
                  onPhoneValidation: _cache[3] || (_cache[3] = ($event: any) => (phoneValidation.value = { ...phoneValidation.value, ...$event})),
                  onImageValidation: _cache[4] || (_cache[4] = ($event: any) => (imageValidationHandler($event)))
                }, null, 8, ["model", "fields"]))
              }), 256))
        ]),
        _: 1
      }, 16, ["rules", "model"]))
    : _createCommentVNode("", true)
}
}

})